import { render, staticRenderFns } from "./IconChevronLeft.vue?vue&type=template&id=2509db9f&"
import script from "./IconChevronLeft.vue?vue&type=script&lang=js&"
export * from "./IconChevronLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports